import React, { useState, useEffect, useCallback } from "react";
import "./Memarts.css"; // We'll create this CSS file separately

const Memarts = () => {
  // ---------- ДАННЫЕ УРОКОВ (масштабируемая структура) ----------
  const lessons = {
    0: {
      1: {
        lvl: "Unspecified",
        lesson: "Unspecified",
        title: "Irregular Verbs",
        words: [
          {
            english: "arise - arose - arisen",
            russian: "возникать, появляться",
          },
          {
            english: "be - was/were - been",
            russian: "быть",
          },
          {
            english: "bear - bore - borne / born",
            russian: "выносить, выдерживать, рождать",
          },
          {
            english: "beat - beat - beaten",
            russian: "бить",
          },
          {
            english: "become - became - become",
            russian: "становиться, превращаться",
          },
          {
            english: "begin - began - begun",
            russian: "начинать",
          },
          {
            english: "bend - bent - bent",
            russian: "гнуть(ся), сгибать",
          },
          {
            english: "bet - bet - bet",
            russian: "держать пари",
          },
          {
            english: "bid (at a public sale) - bid - bid",
            russian: "предлагать цену, торговаться",
          },
          {
            english: "bid (ask) - bade/bid - bidden/bid",
            russian: "просить, велеть",
          },
          {
            english: "bind - bound - bound",
            russian: "связывать",
          },
          {
            english: "bite - bit - bitten",
            russian: "кусать",
          },
          {
            english: "bleed - bled - bled",
            russian: "кровоточить",
          },
          {
            english: "blow - blew - blown",
            russian: "дуть",
          },
          {
            english: "break - broke - broken",
            russian: "ломать, разбивать",
          },
          {
            english: "break up - broke up - broken up",
            russian: "расстаться",
          },
          {
            english: "breed - bred - bred",
            russian: "разводить (животных), воспитывать",
          },
          {
            english: "bring up - brought up - brought up",
            russian: "растить, воспитывать (о детях)",
          },
          {
            english:
              "broadcast - broadcast/broadcasted - broadcast/broadcasted",
            russian: "транслировать",
          },
          {
            english: "build - built - built",
            russian: "строить",
          },
          {
            english: "burn - burnt/burned - burnt/burned",
            russian: "гореть, жечь, сжигать",
          },
          {
            english: "burst - burst - burst",
            russian: "взрываться, лопаться",
          },
          {
            english: "buy - bought - bought",
            russian: "покупать",
          },
          {
            english: "cast - cast - cast",
            russian: "бросать, кидать, лить (металл)",
          },
          {
            english: "catch - caught - caught",
            russian: "ловить, поймать",
          },
          {
            english: "choose - chose - chosen",
            russian: "выбирать",
          },
          {
            english: "cling - clung - clung",
            russian: "цепляться, прилипать",
          },
          {
            english: "come - came - come",
            russian: "приходить",
          },
          {
            english: "cost - cost - cost",
            russian: "стоить (по цене/деньгам)",
          },
          {
            english: "creep - crept - crept",
            russian: "ползать, красться",
          },
          {
            english: "cut - cut - cut",
            russian: "резать",
          },
          {
            english: "deal with - dealt - dealt",
            russian: "иметь дело с__",
          },
          {
            english: "dig - dug - dug",
            russian: "копать",
          },
          {
            english: "do - did - done",
            russian: "делать, заниматься чем-то, выполнять",
          },
          {
            english: "draw - drew - drawn",
            russian: "рисовать карандашом, чертить",
          },
          {
            english: "dream - dreamt/dreamed - dreamt/dreamed",
            russian: "мечтать, сниться",
          },
          {
            english: "drink - drank - drunk",
            russian: "пить",
          },
          {
            english: "drive - drove - driven",
            russian: "водить (ехать) (авто или любой др.транспорт колесный)",
          },
          {
            english: "dwell - dwelt/dwelled - dwelt/dwelled",
            russian: "обитать, проживать",
          },
          {
            english: "eat - ate - eaten",
            russian: "есть (кушать)",
          },
          {
            english: "fall - fell - fallen",
            russian: "падать",
          },
          {
            english: "feed - fed - fed",
            russian: "кормить",
          },
          {
            english: "feel - felt - felt",
            russian: "чувствовать",
          },
          {
            english: "fight - fought - fought",
            russian: "драться",
          },
          {
            english: "find - found - found",
            russian: "находить",
          },
          {
            english: "fit - fit/fitted - fit/fitted",
            russian: "соответствовать, подходить",
          },
          {
            english: "flee - fled - fled",
            russian: "убегать, спасаться бегством",
          },
          {
            english: "fly - flew - flown",
            russian: "летать",
          },
          {
            english: "forbid - forbade/forbad - forbidden",
            russian: "запрещать",
          },
          {
            english: "forget - forgot - forgotten",
            russian: "забывать",
          },
          {
            english: "forgive - forgave - forgiven",
            russian: "прощать",
          },
          {
            english: "forsake - forsook - forsaken",
            russian: "бросать, покидать, отвергать, забрасывать",
          },
          {
            english: "foresee - foresaw - foreseen",
            russian: "предвидеть",
          },
          {
            english: "freeze - froze - frozen",
            russian: "замораживать",
          },
          {
            english: "get - got - got / gotten",
            russian: "получать, добираться куда-то",
          },
          {
            english: "give - gave - given",
            russian: "давать, дарить",
          },
          {
            english: "go - went - gone",
            russian: "идти, ехать, ходить куда то",
          },
          {
            english: "grind - ground - ground",
            russian: "молоть, точить",
          },
          {
            english: "grow - grew - grown",
            russian: "расти, выращивать",
          },
          {
            english: "hang - hung/hanged - hung/hanged",
            russian: "висеть, вешать /казнить(-ed)",
          },
          {
            english: "have - had - had",
            russian: "иметь, есть (у меня есть брат)",
          },
          {
            english: "hear - heard - heard",
            russian: "слышать",
          },
          {
            english: "hide - hid - hidden",
            russian: "прятать(ся)",
          },
          {
            english: "hit - hit - hit",
            russian: "ударить",
          },
          {
            english: "hoist - hoist/hoisted - hoist/hoisted",
            russian: "поднимать (флаг, парус)",
          },
          {
            english: "hold - held - held",
            russian: "держать, удерживать",
          },
          {
            english: "hurt - hurt - hurt",
            russian:
              "повредить, ранить (и физически, и ментально), болеть (болит нога или болит душа)",
          },
          {
            english: "keep - kept - kept",
            russian: "хранить, сохранять",
          },
          {
            english: "kneel - knelt/kneeled - knelt/kneeled",
            russian: "становиться на колени, преклонять колено",
          },
          {
            english: "knit - knit/knitted - knit/knitted",
            russian: "вязать, срастаться",
          },
          {
            english: "know - knew - known",
            russian: "знать",
          },
          {
            english: "lay - laid - laid",
            russian: "класть, положить (синоним put)",
          },
          {
            english: "lead - led - led",
            russian: "вести, руководить",
          },
          {
            english: "lean - leant/leaned - leant/leaned",
            russian: "опираться, наклоняться, облакотиться",
          },
          {
            english: "leap - leapt/leaped - leapt/leaped",
            russian: "прыгать",
          },
          {
            english: "learn - learnt/learned - learnt/learned",
            russian: "учить, выучить, узнать",
          },
          {
            english: "leave - left - left",
            russian: "уходить, покидать, уезжать",
          },
          {
            english: "lend - lent - lent",
            russian: "одалживать (давать в долг)",
          },
          {
            english: "let - let - let",
            russian: "позволять, разрешать",
          },
          {
            english: "lie - lay - lain",
            russian: "лежать",
          },
          {
            english: "lie - lied - lied",
            russian: "лгать, врать",
          },
          {
            english: "light - lit/lighted - lit/lighted",
            russian: "зажигать, освещать",
          },
          {
            english: "lose - lost - lost",
            russian: "проигрывать, терять",
          },
          {
            english: "make - made - made",
            russian: "делать, создавать(руками)",
          },
          {
            english: "make the bed - made the bed - made the bed",
            russian: "заправлять кровать",
          },
          {
            english: "mean - meant - meant",
            russian: "иметь в виду, значить",
          },
          {
            english: "meet - met - met",
            russian: "встречаться ,видеться",
          },
          {
            english: "mislead - misled - misled",
            russian: "вводить в заблуждение",
          },
          {
            english: "misunderstand - misunderstood - misunderstood",
            russian: "неправильно понять",
          },
          {
            english: "mow - mowed - mown/mowed",
            russian: "косить (траву)",
          },
          {
            english: "overcome - overcame - overcome",
            russian: "преодолеть",
          },
          {
            english: "overdo - overdid - overdone",
            russian: "преувеличивать, перестараться/переборщить, пережарить",
          },
          {
            english: "oversleep - overslept - overslept",
            russian: "проспать",
          },
          {
            english: "overtake - overtook - overtaken",
            russian: "обогнать",
          },
          {
            english: "pay - paid - paid",
            russian: "платить",
          },
          {
            english: "plead - pled/pleaded - pled/pleaded",
            russian: "умолять, защищать в суде",
          },
          {
            english: "prove - proved - proved/proven",
            russian: "доказывать",
          },
          {
            english: "put - put - put",
            russian: "положить, класть",
          },
          {
            english: "quit - quit - quit",
            russian: "уволиться, бросить(прекратить) что-то делать",
          },
          {
            english: "read - read (red) - read (red)",
            russian: "читать",
          },
          {
            english: "ride - rode - ridden",
            russian:
              "кататься (верхом, на велосипеде, периодически можно встретить с авто, автобусом, просьбой подбросить куда-то)",
          },
          {
            english: "ring - rang - rung",
            russian: "звонить (так же о звонке дверном, или о телефоне)",
          },
          {
            english: "rise - rose - risen",
            russian: "подниматься, вставать",
          },
          {
            english: "run - ran - run",
            russian: "бегать",
          },
          {
            english: "saw - sawed - sawn/sawed",
            russian: "пилить",
          },
          {
            english: "say - said - said",
            russian: "говорить, сказать",
          },
          {
            english: "see - saw - seen",
            russian: "видеть",
          },
          {
            english: "see off - saw off - seen off",
            russian: "провожать кого-то",
          },
          {
            english: "seek - sought - sought",
            russian: "искать",
          },
          {
            english: "sell - sold - sold",
            russian: "продавать",
          },
          {
            english: "send - sent - sent",
            russian: "отправлять, посылать",
          },
          {
            english: "set - set - set",
            russian: "устанавливать, накрывать (на стол)",
          },
          {
            english: "sew - sewed - sewn/sewed",
            russian: "шить",
          },
          {
            english: "shake - shook - shaken",
            russian: "трясти, встряхивать",
          },
          {
            english: "shear - shore/sheared - shorn/sheared",
            russian: "стричь (овец)",
          },
          {
            english: "shed - shed - shed",
            russian: "проливать (слезы, кровь), сбрасывать",
          },
          {
            english: "shine - shone / shined - shone / shined",
            russian: "сиять, светить",
          },
          {
            english: "shoot - shot - shot",
            russian: "стрелять, забить (гол)",
          },
          {
            english: "show - showed - shown",
            russian: "показывать",
          },
          {
            english: "shrink - shrank - shrunk",
            russian: "сжиматься, уменьшаться",
          },
          {
            english: "shut - shut - shut",
            russian: "закрывать",
          },
          {
            english: "sing - sang - sung",
            russian: "петь",
          },
          {
            english: "sink - sank - sunk",
            russian: "тонуть, погружаться (о транспорт.средстве - корабль)",
          },
          {
            english: "sit - sat - sat",
            russian: "сидеть",
          },
          {
            english: "sleep - slept - slept",
            russian: "спать",
          },
          {
            english: "slide - slid - slid",
            russian: "скользить",
          },
          {
            english: "smell - smelt/smelled - smelt/smelled",
            russian: "пахнуть, нюхать",
          },
          {
            english: "sow - sowed - sown/sowed",
            russian: "сеять",
          },
          {
            english: "speak with - spoke with - spoken with",
            russian:
              "разговаривать с (официально один перед группой, или на каком-то языке)",
          },
          {
            english: "speed up - sped/speeded up - sped/speeded up",
            russian: "ускориться",
          },
          {
            english: "spell - spelt/spelled - spelt/spelled",
            russian: "произносить по буквам",
          },
          {
            english: "spend - spent - spent",
            russian: "проводить (время), тратить (время, деньги)",
          },
          {
            english: "spill - spilt/spilled - spilt/spilled",
            russian: "проливать, рассыпать",
          },
          {
            english: "spin - span/spun - spun",
            russian: "крутить, прясть",
          },
          {
            english: "spit - spat/spit - spat/spit",
            russian: "плевать",
          },
          {
            english: "split (the bill) - split - split",
            russian: "разделять (счёт)",
          },
          {
            english: "spread - spread - spread",
            russian: "распространять",
          },
          {
            english: "spring - sprang - sprung",
            russian: "прыгать, возникать",
          },
          {
            english: "stand - stood - stood",
            russian: "стоять",
          },
          {
            english: "steal - stole - stolen",
            russian: "красть, воровать",
          },
          {
            english: "sting - stung - stung",
            russian: "жалить, ужалить",
          },
          {
            english: "strive - strove/strived - striven/strived",
            russian: "стремиться, стараться",
          },
          {
            english: "swear - swore - sworn",
            russian: "клясться, ругаться",
          },
          {
            english: "sweat - sweat/sweated - sweat/sweated",
            russian: "потеть",
          },
          {
            english: "sweep - swept / sweeped - swept / sweeped",
            russian: "подметать",
          },
          {
            english: "swell - swelled - swollen/swelled",
            russian: "опухать, увеличиваться",
          },
          {
            english: "swim - swam - swum",
            russian: "плавать",
          },
          {
            english: "swing - swung - swung",
            russian: "качать, размахивать",
          },
          {
            english: "take - took - taken",
            russian: "брать, взять",
          },
          {
            english: "take off - took off - taken off",
            russian: "снимать одежду, взлетать",
          },
          {
            english: "teach - taught - taught",
            russian: "учить(кого-то)",
          },
          {
            english: "tear - tore - torn",
            russian: "рвать",
          },
          {
            english: "tell - told - told",
            russian: "рассказывать, сказать кому-то",
          },
          {
            english: "think - thought - thought",
            russian: "думать, считать/полагать",
          },
          {
            english: "throw - threw - thrown",
            russian: "кидать, бросать, швырять",
          },
          {
            english: "thrive - throve/thrived - thriven/thrived",
            russian: "процветать",
          },
          {
            english: "tread - trod - trod/trodden",
            russian: "ступать, наступать",
          },
          {
            english: "understand - understood - understood",
            russian: "понимать",
          },
          {
            english: "undertake - undertook - undertaken",
            russian: "предпринимать, браться, ручаться",
          },
          {
            english: "wake - woke - woken",
            russian: "просыпаться, будить",
          },
          {
            english: "wake up - woke up - woken up",
            russian: "просыпаться",
          },
          {
            english: "wear - wore - worn",
            russian: "носить",
          },
          {
            english: "weave - wove - woven",
            russian: "ткать, плести",
          },
          {
            english: "weep - wept - wept",
            russian: "плакать",
          },
          {
            english: "wet - wet/wetted - wet/wetted",
            russian: "мочить, смачивать",
          },
          {
            english: "win - won - won",
            russian: "выигрывать",
          },
          {
            english: "wind - wound - wound",
            russian: "виться, заводить (часы)",
          },
          {
            english: "withhold - withheld - withheld",
            russian: "скрывать, утаивать",
          },
          {
            english: "withstand - withstood - withstood",
            russian: "выстоять, выдержать",
          },
          {
            english: "write - wrote - written",
            russian: "писать",
          },
        ],
      },
    },
    999: {
      1: {
        lvl: "1",
        lesson: "1",
        title: "Tourism",
        words: [
          {
            english: "Travel",
            russian: "Путешествие",
          },
          {
            english: "Trip",
            russian: "Поездка",
          },
          {
            english: "Itinerary",
            russian: "Маршрут / План поездки",
          },
          {
            english: "Reservation",
            russian: "Бронирование",
          },
          {
            english: "Booking",
            russian: "Бронирование / Заказ",
          },
          {
            english: "Ticket",
            russian: "Билет",
          },
          {
            english: "One-way ticket",
            russian: "Билет в один конец",
          },
          {
            english: "Round-trip/return ticket",
            russian: "Билет туда и обратно",
          },
          {
            english: "Flight",
            russian: "Рейс / Перелёт",
          },
          {
            english: "Direct flight",
            russian: "Прямой рейс",
          },
          {
            english: "Aisle seat",
            russian: "Место у прохода",
          },
          {
            english: "Window seat",
            russian: "Место у окна",
          },
          {
            english: "Boarding pass",
            russian: "Посадочный талон",
          },
          {
            english: "Check-in baggage",
            russian: "Багаж для сдачи",
          },
          {
            english: "Carry-on luggage",
            russian: "Ручная кладь",
          },
          {
            english: "Departure",
            russian: "Отправление / Вылет",
          },
          {
            english: "Arrival",
            russian: "Прибытие",
          },
          {
            english: "Delay",
            russian: "Задержка",
          },
          {
            english: "Cancel",
            russian: "Отменить",
          },
          {
            english: "Confirm",
            russian: "Подтвердить",
          },
          {
            english: "Passenger",
            russian: "Пассажир",
          },
          {
            english: "Passport",
            russian: "Паспорт",
          },
          {
            english: "Visa",
            russian: "Виза",
          },
          {
            english: "Reception(desk)",
            russian: "Стойка регистрации",
          },
          {
            english: "Check-in",
            russian: "Регистрация, заезд",
          },
          {
            english: "Check-out",
            russian: "Выезд",
          },
          {
            english: "Look forward to",
            russian: "Ожидать с нетерпением",
          },
          {
            english: "Depart from",
            russian: "Отправляться из",
          },
        ],
      },
      2: {
        lvl: "1",
        lesson: "2",
        title: "Small Talk",
        words: [
          {
            english: "Small talk",
            russian: "Светская беседа / Разговор ни о чём",
          },
          {
            english: "Break the ice",
            russian: "Сломать лёд / Начать разговор",
          },
          {
            english: "Stranger",
            russian: "Незнакомец",
          },
          {
            english: "Chat",
            russian: "Болтать / Беседа",
          },
          {
            english: "Conversation starter",
            russian: "Способ начать разговор",
          },
          {
            english: "Awkward",
            russian: "Неловкий",
          },
          {
            english: "Polite",
            russian: "Вежливый",
          },
          {
            english: "Rude",
            russian: "Грубый",
          },
          {
            english: "Interrupt",
            russian: "Перебивать",
          },
          {
            english: "Get a word in edgeways",
            russian: "Вставить слово",
          },
          {
            english: "Hobby",
            russian: "Хобби / Увлечение",
          },
          {
            english: "Occupation",
            russian: "Профессия / Род занятий",
          },
          {
            english: "What do you do?",
            russian: "Кем вы работаете?",
          },
          {
            english: "Travel story",
            russian: "История о путешествии",
          },
          {
            english: "Destination",
            russian: "Место назначения",
          },
          {
            english: "Abroad",
            russian: "За границей",
          },
          {
            english: "Culture shock",
            russian: "Культурный шок",
          },
          {
            english: "Recommend",
            russian: "Рекомендовать",
          },
          {
            english: "Sightseeing",
            russian: "Осмотр достопримечательностей",
          },
          {
            english: "Local",
            russian: "Местный житель",
          },
          {
            english: "Exhausted",
            russian: "Измученный",
          },
          {
            english: "Nap",
            russian: "Вздремнуть",
          },
          {
            english: "Exit strategy",
            russian: "Стратегия выхода из разговора",
          },
          {
            english: "Wind down",
            russian: "Заканчивать / Сворачивать разговор",
          },
          {
            english: "Nice chatting with you",
            russian: "Было приятно поболтать",
          },
          {
            english: "I should let you go",
            russian: "Мне пора вас отпустить",
          },
          {
            english: "Get some rest",
            russian: "Отдохнуть",
          },
          {
            english: "Catch up",
            russian: "Встретиться / Поговорить после перерыва",
          },
          {
            english: "Keep in touch",
            russian: "Оставаться на связи",
          },
          {
            english: "Take care",
            russian: "Береги себя",
          },
        ],
      },
      3: {
        lvl: "1",
        lesson: "3",
        title: "Trains and Railways",
        words: [
          {
            english: "Platform",
            russian: "Платформа / Перрон",
          },
          {
            english: "Track",
            russian: "Путь / Рельсы",
          },
          {
            english: "Platform change",
            russian: "Смена платформы",
          },
          {
            english: "Announcement",
            russian: "Объявление",
          },
          {
            english: "Delay",
            russian: "Задержка",
          },
          {
            english: "On time",
            russian: "Вовремя / По расписанию",
          },
          {
            english: "Cancel / Cancelled",
            russian: "Отменить / Отменён",
          },
          {
            english: "Ticket",
            russian: "Билет",
          },
          {
            english: "Single ticket",
            russian: "Билет в один конец",
          },
          {
            english: "Return ticket",
            russian: "Билет туда и обратно",
          },
          {
            english: "First class",
            russian: "Первый класс",
          },
          {
            english: "Second class / Standard class",
            russian: "Второй класс / Стандартный класс",
          },
          {
            english: "Seat reservation",
            russian: "Бронирование места",
          },
          {
            english: "Reserved seat",
            russian: "Забронированное место",
          },
          {
            english: "Non-reserved seat",
            russian: "Незабронированное место",
          },
          {
            english: "Validate / Stamp",
            russian: "Компостировать / Пробить билет",
          },
          {
            english: "Ticket machine",
            russian: "Билетный автомат",
          },
          {
            english: "Ticket office",
            russian: "Билетная касса",
          },
          {
            english: "Conductor",
            russian: "Кондуктор / Проводник",
          },
          {
            english: "Inspector",
            russian: "Контролёр",
          },
          {
            english: "Fine",
            russian: "Штраф",
          },
          {
            english: "Connection / Connecting train",
            russian: "Пересадка / Стыковочный поезд",
          },
          {
            english: "Miss a connection",
            russian: "Опоздать на пересадку",
          },
          {
            english: "Catch a train",
            russian: "Успеть на поезд",
          },
          {
            english: "Timetable / Schedule",
            russian: "Расписание",
          },
          {
            english: "Departure board",
            russian: "Табло отправления",
          },
          {
            english: "Information desk",
            russian: "Справочное бюро / Информация",
          },
          {
            english: "Passerby",
            russian: "Прохожий",
          },
          {
            english: "Valid",
            russian: "Действительный",
          },
          {
            english: "Expired",
            russian: "Просроченный",
          },
        ],
      },
      4: {
        lvl: "1",
        lesson: "4",
        title: "Airport Procedures",
        words: [
          {
            english: "Check-in counter",
            russian: "Стойка регистрации",
          },
          {
            english: "Self check-in",
            russian: "Самостоятельная регистрация",
          },
          {
            english: "Bag drop",
            russian: "Сдача багажа",
          },
          {
            english: "Security check / Security control",
            russian: "Контроль безопасности",
          },
          {
            english: "Metal detector",
            russian: "Металлоискатель",
          },
          {
            english: "Body scanner",
            russian: "Сканер тела",
          },
          {
            english: "X-ray machine",
            russian: "Рентген-установка",
          },
          {
            english: "Liquid restriction",
            russian: "Ограничение на жидкости",
          },
          {
            english: "100ml / 3.4oz",
            russian: "100 миллилитров",
          },
          {
            english: "Clear plastic bag",
            russian: "Прозрачный пластиковый пакет",
          },
          {
            english: "Laptop out",
            russian: "Достать ноутбук",
          },
          {
            english: "Take off your shoes",
            russian: "Снять обувь",
          },
          {
            english: "Remove your belt",
            russian: "Снять ремень",
          },
          {
            english: "Jacket off",
            russian: "Снять куртку",
          },
          {
            english: "Pat-down",
            russian: "Личный досмотр",
          },
          {
            english: "Random check",
            russian: "Выборочная проверка",
          },
          {
            english: "Transit / Transfer",
            russian: "Транзит / Пересадка",
          },
          {
            english: "Transit visa",
            russian: "Транзитная виза",
          },
          {
            english: "Transfer desk",
            russian: "Стойка трансфера",
          },
          {
            english: "Duty-free shop",
            russian: "Магазин беспошлинной торговли",
          },
          {
            english: "Customs",
            russian: "Таможня",
          },
          {
            english: "Declaration form",
            russian: "Декларация",
          },
          {
            english: "Something to declare",
            russian: "Товары для декларирования",
          },
          {
            english: "Nothing to declare",
            russian: "Нет товаров для декларирования",
          },
          {
            english: "Immigration",
            russian: "Паспортный контроль / Иммиграция",
          },
          {
            english: "Purpose of visit",
            russian: "Цель визита",
          },
          {
            english: "Length of stay",
            russian: "Продолжительность пребывания",
          },
          {
            english: "Proof of onward travel",
            russian: "Подтверждение обратного билета",
          },
          {
            english: "Boarding time",
            russian: "Время посадки",
          },
          {
            english: "Final call",
            russian: "Последняя посадка",
          },
        ],
      },
    },
    1: {},
    2: {
      1: {
        lvl: "2",
        lesson: "1",
        // title: "Word list",
        words: [
          // Существительные (12)
          { english: "a man - men", russian: "мужчина - мужчины" },
          { english: "a woman - women", russian: "женщина - женщины" },
          { english: "a child - children", russian: "ребёнок - дети" },
          { english: "a person - people", russian: "человек - люди" },
          { english: "a plant - plants", russian: "растение - растения" },
          { english: "a tree - trees", russian: "дерево - деревья" },
          { english: "a flower - flowers", russian: "цветок - цветы" },
          {
            english: "an animal - animals",
            russian: "животное - животные",
          },
          { english: "a bird - birds", russian: "птица - птицы" },
          { english: "a thing - things", russian: "вещь - вещи" },
          {
            english: "an object - objects",
            russian: "предмет - предметы",
          },
          { english: "a place - places", russian: "место - места" },
          // Слово "Adjectives" как отдельная карточка
          { english: "Adjectives", russian: "Прилагательные" },
          // Прилагательные (39)
          { english: "friendly", russian: "дружелюбный" },
          { english: "unfriendly", russian: "недружелюбный" },
          { english: "kind", russian: "добрый" },
          { english: "angry", russian: "злой" },
          {
            english: "great",
            russian: "великий, потрясающий, замечательный",
          },
          { english: "new", russian: "новый" },
          { english: "young", russian: "молодой" },
          { english: "old", russian: "старый" },
          { english: "clean", russian: "чистый" },
          { english: "dirty", russian: "грязный" },
          { english: "cute", russian: "миленький, хорошенький" },
          {
            english: "nosy",
            russian: "любопытный, сующий свой нос везде",
          },
          { english: "interesting", russian: "интересный" },
          { english: "boring", russian: "скучный" },
          { english: "funny", russian: "забавный, смешной" },
          { english: "beautiful", russian: "красивый, прекрасный" },
          { english: "active", russian: "активный" },
          { english: "lazy", russian: "ленивый" },
          { english: "crazy", russian: "сумасшедший" },
          { english: "free", russian: "свободный; бесплатный" },
          { english: "busy", russian: "занятой" },
          {
            english: "simple",
            russian:
              "1. простой, легкий (не требующий много усилий при выполнении) 2. простой (выполненный без каких-либо излишеств)",
          },
          {
            english: "difficult",
            russian: "трудный (в выполнении или понимании)",
          },
          { english: "easy", russian: "простой, легкий" },
          { english: "hard", russian: "трудный, сложный" },
          { english: "fat", russian: "толстый; жирный" },
          { english: "slim", russian: "худой, стройный" },
          { english: "nice", russian: "милый, приятный" },
          { english: "small", russian: "маленький" },
          {
            english: "little",
            russian: "маленький по возрасту или количеству",
          },
          { english: "large", russian: "очень большой" },
          { english: "excellent", russian: "превосходный" },
          { english: "stupid", russian: "глупый, неразумный" },
          { english: "weak", russian: "слабый" },
          { english: "rich", russian: "богатый" },
          { english: "poor", russian: "бедный" },
          { english: "mean", russian: "подлый, скупой, недобрый" },
          { english: "light", russian: "лёгкий (по весу)" },
          { english: "heavy", russian: "тяжёлый (по весу)" },
        ],
      },
      2: {
        lvl: "2",
        lesson: "2",
        // title: "Word list",
        words: [
          { english: "in/at the office", russian: "в офисе" },
          { english: "in/at the classroom", russian: "в классе" },
          { english: "in/at the restaurant", russian: "в ресторане" },
          { english: "in/at the cafe", russian: "в кафе" },
          { english: "in/at the cottage", russian: "в коттедже" },
          { english: "in/at the swimming pool", russian: "в бассейне" },
          { english: "in/at the post office", russian: "на почте" },
          { english: "in/at the hospital", russian: "в больнице" },
          { english: "in the mountains", russian: "в горах" },
          { english: "in America", russian: "в Америке" },
          {
            english: "in Saint Petersburg",
            russian: "в Санкт-Петербурге",
          },
          { english: "in the village", russian: "в деревне" },
          {
            english: "in the country",
            russian: "за городом / в сельской местности",
          },
          { english: "in the city", russian: "в городе" },
          { english: "in the park", russian: "в парке" },
          { english: "at the party", russian: "на вечеринке" },
          { english: "at the concert", russian: "на концерте" },
          { english: "at the spa", russian: "в спа" },
          { english: "at the lesson", russian: "на уроке" },
          { english: "at the meeting", russian: "на встрече" },
          { english: "at the theatre", russian: "в театре" },
          { english: "at the university", russian: "в университете" },
          { english: "at work", russian: "на работе" },
          { english: "at school", russian: "в школе" },
          { english: "at home", russian: "дома" },
          { english: "in church", russian: "в церкви" },
          { english: "in prison", russian: "в тюрьме" },
          { english: "abroad", russian: "за границей" },
          { english: "near", russian: "рядом, близко" },
          { english: "far (from)", russian: "далеко (от)" },
          {
            english: "in the street (UK) / on the street (US)",
            russian: "на улице",
          },
        ],
      },
    },

    3: {},
    4: {},
    5: {},
    6: {},
    7: {},
    8: {},
    9: {},
  };

  // ---------- СОСТОЯНИЕ ----------
  const [currentLevel, setCurrentLevel] = useState(0);
  const [currentLesson, setCurrentLesson] = useState(1);
  const [deck, setDeck] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [englishFirstMode, setEnglishFirstMode] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // ---------- ЭФФЕКТЫ ----------
  useEffect(() => {
    loadLesson();
  }, [currentLevel, currentLesson]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // Close menu when switching to desktop
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    updateDocumentTitle();
  }, [currentLevel, currentLesson, deck]);

  // ---------- ФУНКЦИИ ----------
  const getCurrentLessonData = useCallback(() => {
    return lessons[currentLevel]?.[currentLesson];
  }, [currentLevel, currentLesson]);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isMenuOpen &&
        !e.target.closest(".burger-menu") &&
        !e.target.closest(".burger-btn")
      ) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMenuOpen]);

  const loadLesson = () => {
    const lessonData = getCurrentLessonData();
    if (!lessonData) return;

    setDeck([...lessonData.words]);
    setCurrentIndex(0);
    setEnglishFirstMode(true);
    setIsFlipped(false);
  };

  const updateDocumentTitle = () => {
    const lessonData = getCurrentLessonData();
    if (lessonData) {
      document.title = `Карточки · ${lessonData.words.length} слов · ${lessonData.title}`;
    }
  };

  const handleCardClick = () => {
    if (!isFlipped) {
      setIsFlipped(true);
    } else {
      nextCard();
    }
  };

  const nextCard = () => {
    setCurrentIndex((prev) => (prev + 1) % deck.length);
    setIsFlipped(false);
  };

  const shuffleDeck = () => {
    if (deck.length <= 1) return;

    const shuffled = [...deck];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    setDeck(shuffled);
    setCurrentIndex(0);
    setIsFlipped(false);
  };

  const switchLanguageMode = () => {
    setEnglishFirstMode((prev) => !prev);
    setIsFlipped(false); // Reset flip state when switching language mode
  };

  const switchLevel = (levelNum) => {
    setCurrentLevel(levelNum);
    // Automatically switch to first lesson of the new level
    const firstLesson = Object.keys(lessons[levelNum] || {})
      .map(Number)
      .sort((a, b) => a - b)[0];
    if (firstLesson) {
      setCurrentLesson(firstLesson);
    }
    closeMenu();
  };

  const switchLesson = (lessonNum) => {
    if (lessons[currentLevel]?.[lessonNum]) {
      setCurrentLesson(lessonNum);
      closeMenu();
    }
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight" || e.key === " ") {
        e.preventDefault();
        if (!isFlipped) {
          setIsFlipped(true);
        } else {
          nextCard();
        }
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        setCurrentIndex((prev) => (prev - 1 + deck.length) % deck.length);
        setIsFlipped(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isFlipped, deck.length]);

  // Получить текущие данные карточки
  const currentWord = deck[currentIndex];

  // Получить все номера уроков для навигации
  const lessonNumbers = Object.keys(lessons[currentLevel] || {})
    .map(Number)
    .sort((a, b) => a - b);

  // ---------- РЕНДЕР ----------
  return (
    <div className='deck-container'>
      {/* Desktop Navigation - Always visible */}
      {!isMobile && (
        <div className='desktop-lesson-nav'>
          {lessonNumbers.map((lessonNum) => {
            const lessonData = lessons[currentLevel]?.[lessonNum];
            return (
              <button
                key={lessonNum}
                className={`lesson-btn ${
                  currentLesson === lessonNum ? "active" : ""
                }`}
                onClick={() => switchLesson(lessonNum)}
                title={lessonData?.title}
              >
                Lesson {lessonNum}
              </button>
            );
          })}
        </div>
      )}

      {/* Mobile Burger Button - Only visible on mobile */}
      {
        <button
          className={`burger-btn ${isMenuOpen ? "open" : ""}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      }

      {/* Mobile Menu */}
      {isMenuOpen && (
        <>
          <div className={`burger-menu ${isMenuOpen ? "open" : ""}`}>
            <div className='menu-header'>
              <h3>Lessons</h3>
              <button className='close-menu' onClick={closeMenu}>
                ×
              </button>
            </div>

            <div className='menu-content'>
              {Object.keys(lessons)
                .map(Number)
                .sort((a, b) => a - b)
                .map((levelNum) => {
                  const levelLessons = lessons[levelNum];
                  const hasLessons = Object.keys(levelLessons).length > 0;

                  if (!hasLessons) return null;

                  return (
                    <div key={levelNum} className='menu-level'>
                      <div className='level-title'>
                        {" "}
                        {levelNum === 0
                          ? `Irregular Verbs`
                          : levelNum === 999
                            ? `Tourism`
                            : `Level ${levelNum}`}
                      </div>
                      <div className='level-lessons'>
                        {Object.keys(levelLessons)
                          .map(Number)
                          .sort((a, b) => a - b)
                          .map((lessonNum) => {
                            const lessonData = levelLessons[lessonNum];
                            const isActive =
                              currentLevel === levelNum &&
                              currentLesson === lessonNum;

                            return (
                              <button
                                key={lessonNum}
                                className={`lesson-menu-item ${isActive ? "active" : ""}`}
                                onClick={() => {
                                  if (currentLevel !== levelNum) {
                                    setCurrentLevel(levelNum);
                                  }
                                  switchLesson(lessonNum);
                                }}
                              >
                                <span className='lesson-num'>
                                  {lessonData.lvl &&
                                  lessonData.lesson &&
                                  lessonData.lvl !== "Unspecified"
                                    ? `Lvl ${lessonData.lvl} · Lesson ${lessonData.lesson}`
                                    : ``}
                                </span>
                                <span className='lesson-title'>
                                  {lessonData.title}
                                </span>
                                <span className='word-count'>
                                  {lessonData.words.length} words
                                </span>
                              </button>
                            );
                          })}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          {isMenuOpen && (
            <div className='menu-overlay' onClick={closeMenu}></div>
          )}
        </>
      )}

      <h1>
        {getCurrentLessonData()?.title ||
          `Level ${currentLevel} Lesson ${currentLesson}`}
      </h1>

      <div className='subtitle'>
        👆 нажми на слово → перевод → ещё раз → следующее
      </div>

      {/* Rest of your existing JSX */}
      <div className='counter-header'>
        <span className='counter'>
          {deck.length > 0 ? `${currentIndex + 1} / ${deck.length}` : "0 / 0"}
        </span>
      </div>

      <div className='card-wrapper'>
        {/* Your card component */}
        <div
          className={`card ${isFlipped ? "flipped" : ""}`}
          onClick={handleCardClick}
        >
          <div className='card-inner'>
            <div className='card-front'>
              {currentWord && (
                <>
                  <div className='word'>
                    {englishFirstMode
                      ? currentWord.english
                      : currentWord.russian}
                  </div>
                  <div className='badge'>{englishFirstMode ? "EN" : "RU"}</div>
                </>
              )}
            </div>
            <div className='card-back'>
              {currentWord && (
                <>
                  <div className='word'>
                    {englishFirstMode
                      ? currentWord.russian
                      : currentWord.english}
                  </div>
                  <div className='badge'>{englishFirstMode ? "RU" : "EN"}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='controls-panel'>
        <button className='ctrl-btn' onClick={shuffleDeck}>
          Shuffle
        </button>
        <button className='ctrl-btn' onClick={switchLanguageMode}>
          {englishFirstMode ? "EN → RU" : "RU → EN"}
        </button>
      </div>
    </div>
  );
};

export default Memarts;
